import SyncOneSignalInstance from './scripts/sync-one-signal'
import ResizeObserver from 'resize-observer-polyfill';
import './util/polyfill';

if ('ResizeObserver' in window) {
  // already exists
} else {
  window.ResizeObserver = ResizeObserver;
}

if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(search, replace) {
    // If search is a string, escape any RegExp special characters
    if (typeof search === 'string') {
      search = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    return this.replace(new RegExp(search, 'g'), replace);
  };
}


if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('./../sw.js', {scope: './../'})
    .then((reg) => {
      // registration worked
      console.log('Registration succeeded. Scope is ' + reg.scope);
    }).catch((error) => {
    // registration failed
    console.log('Registration failed with ' + error);
  });
}

import CacheInstance from './components/cache';
import './scripts/global-functions';
import SiteMessagesInstance from './components/site-messages';
import UserNotifications from './components/user-notifications';
import PubSub from "pubsub-js";

window.PubSub = PubSub;

const $ = window.$;

$('.app-menu-toggle').on('click', () => {
  $('.app-menu').toggleClass('is-collapsed');
});

import './scripts/groups';

window.getDewpoint = (humidity, temperature, displayFormat = true) => {

 let dewpoint = Math.pow((parseFloat(humidity) / 100), 1 / 8) * (112 + (0.9 * parseFloat(temperature))) + (0.1 * parseFloat(temperature)) - 112;
  dewpoint = celsiusToUserTemp(dewpoint, 1);

  if(displayFormat) {
    return dewpoint  + `&deg;${window.getUserTempPref()}`;
  } else {
    return dewpoint;
  }

}

// Templates
import './templates/dashboard';
import './templates/login';
import './templates/forgot-password';
import './templates/notifications';
import './templates/service-status';
import UserNoticesInstance from './components/user-notices'
import userLoggedIn from './scripts/user-logged-in'
import UserNotificationsInstance from './components/user-notifications'
import isAccountReadOnly from './scripts/is-account-read-only'
import isAccountSupport from './scripts/is-account-support'
import RequestQueueInstance from './util/request-queue'
import isAccountEnterprise from './scripts/is-account-enterprise'

$(document).ready(() => {
  SiteMessagesInstance.displayMessages();
});

let resizeDebounce = null;

$(window).resize(() => {

  if(resizeDebounce) {
    clearTimeout(resizeDebounce);
  }

  resizeDebounce = setTimeout(() => {
    window.PubSub.publish('window.resize', window.innerWidth);
  }, 100);

});

let offlineMessageTimeout = null;

window.PubSub.subscribe('offline', () => {

  if(!offlineMessageTimeout && !window.is_onboarding) {

    // wait 70 seconds (enough time to do a notifications check) before showing an offline message
    offlineMessageTimeout = setTimeout(() => {

      let message = `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" style="width:20px;height:auto;vertical-align:text-top;"><defs><style>.a{fill:#fff;}</style></defs><path class="a" d="M26.54,8.8,43.46,38.11a1.77,1.77,0,0,1-1.54,2.66H8.08a1.77,1.77,0,0,1-1.54-2.66L23.46,8.8A1.78,1.78,0,0,1,26.54,8.8ZM26.62,29l.63-8.35a2.17,2.17,0,0,0-2.16-2.32h-.18a2.17,2.17,0,0,0-2.16,2.32L23.36,29a1.54,1.54,0,0,0,1.54,1.43h.18A1.54,1.54,0,0,0,26.62,29ZM25,31.54a2.26,2.26,0,1,0,2.25,2.25A2.25,2.25,0,0,0,25,31.54Z"/></svg> 
      No internet connection.
      `;

      if (window.site.isApp) {
        message += ' Pull down to refresh when you have a connection.';
      } else {
        message += ' Refresh the page when you have a connection.';
      }

      SiteMessagesInstance.addMessage(
        'offline',
        message,
        {
          autoClose: false,
          closeButton: false,
          id: 'offline',
          save: 0,
        }
      );

      SiteMessagesInstance.displayMessages(false);

    }, 70000);

  }

});

window.PubSub.subscribe('online', () => {

  clearTimeout(offlineMessageTimeout);

  console.log('online');
  SiteMessagesInstance.removeMessageById('offline');

});

window.PubSub.subscribe('user_authenticated', () => {

  $(document).ready(() => {

    UserNoticesInstance.getNotices().then(() => {
      UserNoticesInstance.showNotices();
    });

    // run any queued up requests from being offline
    RequestQueueInstance.run();

  });

  UserNotifications.getNotifications().then(() => {
    UserNotifications.updateBadges();
  });

  if(isAccountReadOnly()) {

    SiteMessagesInstance.addMessage('read-only', '<i class="far fa-info-circle"></i> You are using a read-only account, your account can\'t make changes to settings', {
      autoClose: false,
      save: false,
      closeButton: false,
    });

    SiteMessagesInstance.displayMessages(false);

  } else if(isAccountSupport()) {

    SiteMessagesInstance.addMessage('support', `<i class="far fa-info-circle"></i> You are logged in with a support account managing <b>${window.currentUser.sub_user.parent.email}</b>`, {
      autoClose: false,
      save: false,
      closeButton: false,
    });

    SiteMessagesInstance.displayMessages(false);

  } else if(isAccountEnterprise()) {

    SiteMessagesInstance.addMessage('support', `<i class="far fa-info-circle"></i> You are an Enterprise Admin managing <b>${window.currentUser.sub_user.parent.email}</b>`, {
      autoClose: false,
      save: false,
      closeButton: false,
    });

    SiteMessagesInstance.displayMessages(false);

  }

  let doNotificationsInterval = true;
  let notificationsIntervalTime = Date.now();

  $(window).on('blur', () => {
    doNotificationsInterval = false;
  });

  $(window).on('focus', () => {
    doNotificationsInterval = true;
    SiteMessagesInstance.removeMessageById('offline');
  });

  setInterval(() => {

    if(!doNotificationsInterval) {
      return;
    }

    if(Date.now() - notificationsIntervalTime < 30000) {
      return;
    }

    notificationsIntervalTime = Date.now();

    UserNotifications.getNotifications().then(() => {
      UserNotifications.updateBadges();
    });

  }, 60000);

});

window.gonative_device_info = info => {
  CacheInstance.save('device', info);
}

window.gonative_onesignal_info = data => {

  console.log('One Signal Loaded');
  SyncOneSignalInstance.maybeSyncOneSignal(data);
  window.PubSub.publish('one-signal.loaded', data);

}

window.gonative_library_ready = () => {

  console.log('Device info');
  window.gonative.run.deviceInfo();

  console.log('Getting One Signal Info');
  window.gonative.onesignal.run.onesignalInfo();

  if(
    window.gonative &&
    window.gonative.nativebridge &&
    window.gonative.nativebridge.maybeCachePage
  ) {

    let currentUrl = window.location.href;

    window.gonative.nativebridge.maybeCachePage({
      url: currentUrl
    });

  }

}


